import { useEffect, useState } from "react";
import localize from "../../../../common/localize";
import ReportSectionTitle from "../../../../components/common/ReportSectionTitle";

export default function ReportEventReview({ reviews, eventDetailData }) {
  const [reviewsFiltered, setReviewsFiltered] = useState(null);

  useEffect(() => {
    if (reviews?.length > 0) {
      setReviewsFiltered(reviews.filter((x) => !x.Evidence));
    }
  }, [reviews]);

  return (
    <div>
      <ReportSectionTitle title={localize.service_notes} />
      <div className="report_section_without_top_border">
        {reviewsFiltered?.length > 0 &&
          reviewsFiltered.map((item) => (
            <div key={item.Id}>
              <div className="page-break" />
              <div
                className="flex flex-col report_internal_field"
                style={{
                  padding: "5px",
                }}
              >
                <label className="report_little_text">
                  <b>
                    {`${item.Title}, ${localize.reported_by}: ${
                      item.CreatedBy
                    } (${new Date(item.CreationDate).toLocaleString(undefined, {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })})`}
                  </b>
                </label>
                <label className="report_little_text">{item.Observation}</label>
              </div>
            </div>
          ))}

        <div className="page-break" />
        {eventDetailData?.CanEdit === 0 && (
          <div
            className="flex flex-col report_internal_field"
            style={{
              padding: "5px",
            }}
          >
            <label className="report_little_text">
              {eventDetailData?.FinishObservation ? (
                <span className="report_little_text">
                  <b>{localize.conclusions}:</b>{" "}
                  {eventDetailData?.FinishObservation}
                </span>
              ) : (
                localize.finished_without_conslusions
              )}
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
